import { useState } from 'react';

const stories = [
  {
    id: 1,
    author: '幸福的小两口',
    avatar: 'https://public.readdy.ai/ai/img_res/bde6a39645b11d7c860aeceec12913ea.jpg',
    content: '在富缘佳旺认识了我的先生，他是博士学历，我们有共同的价值观。感谢平台的视频验证功能，让我们第一次见面就充满信任！',
    date: '2025年3月',
    likes: 234,
  },
  {
    id: 2,
    author: '北京的张先生',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20man%20portrait%20smiling%2C%20warm%20background%2C%20high%20quality%20photography&width=80&height=80&seq=story002&orientation=squarish',
    content: '通过平台的情感教育课程，我学会了如何更好地表达自己的感情。现在我们已经订婚了，感谢富缘佳旺！',
    date: '2025年2月',
    likes: 189,
  },
  {
    id: 3,
    author: '上海的李女士',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20Chinese%20woman%20portrait%20smiling%2C%20soft%20lighting%2C%20clean%20background%2C%20high%20quality%20photography&width=80&height=80&seq=story003&orientation=squarish',
    content: '平台的学历认证系统非常靠谱，我找到了一位清华硕士，我们有很多共同话题，感情进展很顺利。',
    date: '2025年1月',
    likes: 312,
  },
];

export default function SharingDonation() {
  const [donationAmount, setDonationAmount] = useState(50);
  const [customAmount, setCustomAmount] = useState('');
  const [storyLikes, setStoryLikes] = useState<number[]>([]);
  const [donateSuccess, setDonateSuccess] = useState(false);
  const donationGoal = 100000;
  const donationCurrent = 67800;
  const donationPercent = Math.round((donationCurrent / donationGoal) * 100);

  const toggleStoryLike = (id: number) => {
    setStoryLikes(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleDonate = () => {
    setDonateSuccess(true);
    setTimeout(() => setDonateSuccess(false), 3000);
  };

  return (
    <section id="sharing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            生活分享 · 爱心捐赠
          </h2>
          <p className="text-gray-400 text-sm">Share Life, Share Love — 支持社区公益，关爱婴幼儿教育</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left - Life Sharing */}
          <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-xl">
                <i className="ri-chat-heart-line text-rose-500 text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-800">社区故事分享</h3>
                <p className="text-xs text-gray-400">Community Stories</p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              {stories.map((story) => (
                <div key={story.id} className="bg-white rounded-xl p-4">
                  <div className="flex items-start gap-3 mb-3">
                    <img src={story.avatar} alt={story.author} className="w-10 h-10 rounded-full object-cover object-top flex-shrink-0" />
                    <div>
                      <div className="text-sm font-semibold text-gray-800">{story.author}</div>
                      <div className="text-xs text-gray-400">{story.date}</div>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 mb-3 leading-relaxed">{story.content}</p>
                  <div className="flex items-center justify-between">
                    <button
                      onClick={() => toggleStoryLike(story.id)}
                      className={`flex items-center gap-1.5 text-xs cursor-pointer transition-colors ${storyLikes.includes(story.id) ? 'text-red-500' : 'text-gray-400 hover:text-red-400'}`}
                    >
                      <i className={storyLikes.includes(story.id) ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                      <span>{story.likes + (storyLikes.includes(story.id) ? 1 : 0)}</span>
                    </button>
                    <button className="text-xs text-gray-400 hover:text-gray-600 cursor-pointer">
                      <i className="ri-share-line mr-1"></i>分享
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <button className="w-full mt-4 py-2.5 border border-rose-300 text-rose-600 rounded-full text-sm font-medium hover:bg-rose-50 transition-all cursor-pointer whitespace-nowrap">
              加入讨论 <i className="ri-arrow-right-line ml-1"></i>
            </button>
          </div>

          {/* Right - Donation */}
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl">
                <i className="ri-hand-heart-line text-amber-500 text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-800">爱心捐赠 · 关爱婴幼儿</h3>
                <p className="text-xs text-gray-400">Charitable Giving for Infant Education</p>
              </div>
            </div>

            <div className="bg-white rounded-xl p-4 mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=adorable%20Chinese%20infant%20baby%20in%20warm%20cozy%20setting%2C%20soft%20natural%20lighting%2C%20happy%20expression%2C%20clean%20warm%20background%2C%20high%20quality%20photography%2C%20heartwarming%20scene&width=600&height=200&seq=donate001&orientation=landscape"
                alt="关爱婴幼儿"
                className="w-full h-36 object-cover object-top rounded-lg mb-4"
              />
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                富缘佳旺携手公益组织，为贫困家庭的婴幼儿提供早期教育支持。每一笔小额捐赠，都是对下一代最好的祝福。
              </p>

              {/* Progress */}
              <div className="mb-4">
                <div className="flex justify-between text-xs text-gray-500 mb-1.5">
                  <span>已筹集 ¥{donationCurrent.toLocaleString()}</span>
                  <span>目标 ¥{donationGoal.toLocaleString()}</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2.5">
                  <div
                    className="bg-gradient-to-r from-amber-400 to-orange-500 h-2.5 rounded-full transition-all"
                    style={{ width: `${donationPercent}%` }}
                  ></div>
                </div>
                <div className="text-xs text-amber-600 font-semibold mt-1">{donationPercent}% 已完成 · 1,234 人参与</div>
              </div>

              {/* Amount Selection */}
              <div className="mb-4">
                <label className="text-xs text-gray-500 font-medium mb-2 block">选择捐赠金额</label>
                <div className="flex flex-wrap gap-2 mb-2">
                  {[10, 30, 50, 100, 200].map((amt) => (
                    <button
                      key={amt}
                      onClick={() => { setDonationAmount(amt); setCustomAmount(''); }}
                      className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${donationAmount === amt && !customAmount ? 'bg-amber-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-amber-50'}`}
                    >
                      ¥{amt}
                    </button>
                  ))}
                </div>
                <input
                  type="number"
                  placeholder="自定义金额"
                  value={customAmount}
                  onChange={e => { setCustomAmount(e.target.value); setDonationAmount(0); }}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-amber-400"
                />
              </div>

              {donateSuccess ? (
                <div className="w-full py-3 bg-green-100 text-green-700 rounded-full text-sm font-medium text-center">
                  <i className="ri-check-line mr-1"></i> 感谢您的爱心捐赠！
                </div>
              ) : (
                <button
                  onClick={handleDonate}
                  className="w-full py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full text-sm font-semibold hover:from-amber-600 hover:to-orange-600 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-heart-line mr-1"></i> 立即捐赠 ¥{customAmount || donationAmount}
                </button>
              )}
            </div>

            <div className="flex items-center gap-2 text-xs text-gray-400">
              <i className="ri-shield-check-line text-green-500"></i>
              <span>所有捐款均通过正规公益渠道，透明公开</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
